import {
    Box,
    Flex,
    Text,
    Divider,
    VStack,
    useColorModeValue,
} from "@chakra-ui/react";
import { format } from "date-fns";
import { formatBarcodeMask, formatCurrency } from "@/utils";
import { usePayment } from "@/hooks/usePayment";
  
  
export function BankSlipReviewStep() {
    const bgCard = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("#E2E2E2", "gray.700");
    const { bankSlipData } = usePayment()

    const formattedAmount = formatCurrency({
        value: bankSlipData?.amount ?? 0,
    });

    const formattedDate = bankSlipData?.paymentDate
        ? format(new Date(), "dd/MM/yyyy")
        : "—";

    const formattedBarcode = formatBarcodeMask(bankSlipData?.bankSlipKey);

    return (
        <Flex 
            w="100%" 
            h="100%" 
            direction="column" 
            gap={6}
            justify="center"
        >
            <Text fontSize="22px" fontWeight="400">
                Confira os dados do seu boleto
            </Text>
            <Box border="1px solid" borderColor={borderColor} borderRadius="12px" bg={bgCard}>
                <VStack spacing={0} align="stretch" divider={<Divider />}>
                    <Row label="Beneficiário" value={bankSlipData?.recipientName} />
                    <Row label="Razão social" value={bankSlipData?.recipientDocument} />
                    <Row label="Valor" value={formattedAmount} />
                    <Row label="Vencimento" value={formattedDate} />
                </VStack>
            </Box>
            <Box border="1px solid" borderColor={borderColor} borderRadius="12px" bg={bgCard}>
                <VStack spacing={0} align="stretch" divider={<Divider />}>
                {/* <Row label="Banco" value={bankSlipData?.issuer || "—"} /> */}
                <Flex direction="column" p={4}>
                    <Text fontSize="sm" color="gray.500">
                    Código de barras
                    </Text>
                    <Text fontWeight="medium" wordBreak="break-word">
                    {formattedBarcode}
                    </Text>
                </Flex>
                </VStack>
            </Box>
        </Flex>
    );
}

function Row({
    label,
    value,
}: {
    label: string;
    value?: string | number | null;
}) {
return (
    <Flex align="center" justify="space-between" p={4}>
        <Text fontSize="sm" color="gray.500">
            {label}
        </Text>
        <Text fontWeight="medium">{value ?? "—"}</Text>
    </Flex>
);
}